import yup, {Schema, StringSchema, NumberSchema, BooleanSchema, DateSchema, ArraySchema, MixedSchema, ObjectSchema} from "yup"
import {validate} from "./Input"

export {Schema, StringSchema, NumberSchema, BooleanSchema, DateSchema, ArraySchema, MixedSchema, ObjectSchema}

interface Validator {
  validate: validate
  /** Optionally attach a react component to focus on form invalidation */
  component?: any
}

const validators: Validator[] = []

class Validation {
  validate(currentScreen: string | null = null) {
    const arr = validators.map((validator) => {
      return validator.validate(currentScreen)?.catch((e) => {
        try {
          // Attach the component for use in ValidationInput
          // Serializing this object to avoid circular reference freeze on the native app
          e.component = JSON.parse(JSON.stringify(validator.component))
        } catch (serializationError) {
          console.log("Serialization error:", serializationError)
        }
        throw e
      })
    })

    return Promise.all(arr)
  }

  add(schema: Validator) {
    validators.push(schema)
  }

  remove(schema: Validator) {
    for (let i = 0; i < validators.length; i++) {
      if (schema === validators[i]) {
        validators.splice(i, 1)
        break
      }
    }
  }

  string(msg?: string): StringSchema {
    let schema = yup.string().nullable(true)
    if (msg) {
      schema = schema.required(msg)
    }
    return schema
  }

  number(msg?: string): NumberSchema {
    let schema = yup.number().nullable(true)
    if (msg) {
      schema = schema.required(msg)
    }
    return schema
  }

  boolean(msg?: string): BooleanSchema {
    let schema = yup.boolean().nullable(true)
    if (msg) {
      schema = schema.required(msg)
    }
    return schema
  }

  bool(msg?: string): BooleanSchema {
    return this.boolean(msg)
  }

  date(msg?: string): DateSchema {
    let schema = yup.date().nullable(true)
    if (msg) {
      schema = schema.required(msg)
    }
    return schema
  }

  array<ArrayElementType = any>(msg?: string): ArraySchema<ArrayElementType> {
    let schema = yup.array<ArrayElementType>().nullable(true)
    if (msg) {
      schema = schema.required(msg)
    }
    return schema
  }

  mixed(msg?: string): MixedSchema {
    let schema = yup.mixed().nullable(true)
    if (msg) {
      schema = schema.required(msg)
    }
    return schema
  }

  object<ObjectType = any>(msg?: string): ObjectSchema<ObjectType> {
    let schema = yup.object<ObjectType>().nullable(true)
    if (msg) {
      schema = schema.required(msg)
    }
    return schema
  }

  customError(str?: string, value: any, path: any) {
    if (!str) {
      return true
    }
    return new yup.ValidationError(str, value, path)
  }
}

const validation = new Validation()

export default validation

export {default as validatedScreen} from "./ScreenHoc"
export {default as ValidationInput} from "./Input"
